import * as Oidc from 'oidc-client-ts'
import React, { useMemo } from 'react'
import {
  AuthProvider as OidcProvider,
  type AuthProviderProps,
} from 'react-oidc-context'
import { NAPSTER_BRAND } from '../brands'
import { getClientId, getRedirectUri } from '../utils/authUtils'

const { MODE } = import.meta.env

export const getAuthority = () => {
  switch (MODE) {
    case 'development':
      return 'https://identity.napsterai.dev/'
    case 'staging':
      return 'https://identity.napsteraistage.com/'
    case 'production':
      return 'https://identity.napster.ai/'
    default:
      return 'https://identity.napsterai.dev/'
  }
}

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const oidcConfig: AuthProviderProps = useMemo(() => {
    const isAuthV2 = window.location.search.toLowerCase().includes('auth=v2')
    return isAuthV2
      ? {
          onredirect_callback: () => {},
          authority: getAuthority(),
          client_id: getClientId(),
          redirect_uri: getRedirectUri(),
          scope: `openid profile offline_access ${NAPSTER_BRAND.scope}`,
          post_logout_redirect_uri: `${window.location.origin}/callbackSignOut`,
          userStore: new Oidc.WebStorageStateStore({
            store: window.localStorage,
          }),
        }
      : {
          authority: getAuthority(),
          client_id: getClientId(),
          redirect_uri: getRedirectUri(),
          scope: `openid profile offline_access ${NAPSTER_BRAND.scope}`,
          post_logout_redirect_uri: `${window.location.origin}/callbackSignOut`,
          userStore: new Oidc.WebStorageStateStore({
            store: window.localStorage,
          }),
        }
  }, [])

  return <OidcProvider {...oidcConfig}>{children}</OidcProvider>
}
